import React, { Component } from 'react';
import emailjs from '@emailjs/browser';

import '../Styles/formcontact.css';
import { EMAILJS_CONFIG } from '../config/emailjs';

export default class FormContact extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      message: '',
      mobile: '',
      errors: {},
      isSubmitting: false,
      submitted: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
  }

  /**
   * Handle form field changes
   */
  handleChange(event) {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }));
  }

  /**
   * Validate form
   */
  validateForm() {
    const errors = {};

    const {
      name,
      email,
      message,
      mobile
    } = this.state;

    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const trimmedMessage = message.trim();
    const cleanMobile = mobile.replace(/\D/g, '');

    // Name validation
    if (!trimmedName) {
      errors.name = 'Name is required';
    } else if (trimmedName.length < 2) {
      errors.name = 'Name must be at least 2 characters';
    }

    // Email validation
    if (!trimmedEmail) {
      errors.email = 'Email is required';
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)
    ) {
      errors.email = 'Please enter a valid email address';
    }

    // Mobile validation
    if (!mobile.trim()) {
      errors.mobile = 'Mobile number is required';
    } else if (!/^[6-9]\d{9}$/.test(cleanMobile)) {
      errors.mobile = 'Please enter a valid 10-digit mobile number';
    }

    // Message validation
    if (!trimmedMessage) {
      errors.message = 'Message is required';
    } else if (trimmedMessage.length < 10) {
      errors.message = 'Message must be at least 10 characters';
    }

    return errors;
  }

  /**
   * Reset form after successful submission
   */
  resetForm() {
    this.setState({
      name: '',
      email: '',
      message: '',
      mobile: '',
      errors: {},
      isSubmitting: false,
      submitted: true
    });
  }

  /**
   * Send email through EmailJS
   */
  async sendEmail(e) {
    e.preventDefault();

    // Prevent duplicate submission
    if (this.state.isSubmitting) {
      return;
    }

    // Validate form
    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({
      isSubmitting: true,
      errors: {}
    });

    const {
      name,
      email,
      message,
      mobile
    } = this.state;

    /**
     * These names MUST match the variables
     * configured in your EmailJS template.
     *
     * Contact Us Template:
     * {{from_name}}
     * {{from_email}}
     * {{mobile}}
     * {{message}}
     */
    const templateParams = {
      from_name: name.trim(),
      from_email: email.trim(),
      mobile: mobile.replace(/\D/g, ''),
      message: message.trim()
    };

    try {

      const result = await emailjs.send(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.CONTACT_TEMPLATE_ID,
        templateParams,
        {
          publicKey: EMAILJS_CONFIG.PUBLIC_KEY
        }
      );

      console.log('EmailJS SUCCESS:', result);

      /**
       * If the Contact Us template has an Auto-Reply
       * linked in EmailJS, EmailJS will handle the
       * customer auto-reply.
       */
      this.resetForm();

    } catch (error) {

      console.error('EmailJS FAILED:', error);

      this.setState({
        isSubmitting: false,
        errors: {
          submit:
            'Failed to send message. Please try again. If the problem continues, please contact us directly.'
        }
      });
    }
  }

  render() {

    const {
      name,
      email,
      message,
      mobile,
      errors,
      isSubmitting,
      submitted
    } = this.state;

    return (
      <div className="modern-form-container">

        {submitted ? (

          /* ================= SUCCESS MESSAGE ================= */

          <div className="success-message">

            <div className="success-icon">
              <svg
                width="60"
                height="60"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20 6L9 17L4 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h3>
              Message Sent Successfully!
            </h3>

            <p>
              Thank you for reaching out to us.
              Our team will get back to you as soon as possible.
            </p>

          </div>

        ) : (

          /* ================= CONTACT FORM ================= */

          <form
            onSubmit={this.sendEmail}
            className="modern-form"
            noValidate
          >

            {/* ================= NAME ================= */}

            <div className="form-group">

              <label htmlFor="name">
                <i className="fas fa-user"></i>
                <span>Full Name</span>
              </label>

              <div
                className={`input-wrapper ${
                  errors.name ? 'error' : ''
                }`}
              >

                <input
                  type="text"
                  id="name"
                  name="name"
                  value={name}
                  onChange={this.handleChange}
                  placeholder="Enter your full name"
                  className="form-input"
                  autoComplete="name"
                  disabled={isSubmitting}
                />

                {errors.name && (
                  <span className="error-message">
                    {errors.name}
                  </span>
                )}

              </div>

            </div>


            {/* ================= EMAIL + MOBILE ================= */}

            <div className="form-row">

              {/* EMAIL */}

              <div className="form-group half">

                <label htmlFor="email">
                  <i className="fas fa-envelope"></i>
                  <span>Email Address</span>
                </label>

                <div
                  className={`input-wrapper ${
                    errors.email ? 'error' : ''
                  }`}
                >

                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={this.handleChange}
                    placeholder="your@email.com"
                    className="form-input"
                    autoComplete="email"
                    disabled={isSubmitting}
                  />

                  {errors.email && (
                    <span className="error-message">
                      {errors.email}
                    </span>
                  )}

                </div>

              </div>


              {/* MOBILE */}

              <div className="form-group half">

                <label htmlFor="mobile">
                  <i className="fas fa-phone-alt"></i>
                  <span>Mobile Number</span>
                </label>

                <div
                  className={`input-wrapper ${
                    errors.mobile ? 'error' : ''
                  }`}
                >

                  <input
                    type="tel"
                    id="mobile"
                    name="mobile"
                    value={mobile}
                    onChange={this.handleChange}
                    placeholder="10-digit mobile number"
                    className="form-input"
                    autoComplete="tel"
                    inputMode="numeric"
                    maxLength="10"
                    disabled={isSubmitting}
                  />

                  {errors.mobile && (
                    <span className="error-message">
                      {errors.mobile}
                    </span>
                  )}

                </div>

              </div>

            </div>


            {/* ================= MESSAGE ================= */}

            <div className="form-group">

              <label htmlFor="message">
                <i className="fas fa-comment-dots"></i>
                <span>Your Message</span>
              </label>

              <div
                className={`input-wrapper ${
                  errors.message ? 'error' : ''
                }`}
              >

                <textarea
                  id="message"
                  name="message"
                  value={message}
                  onChange={this.handleChange}
                  placeholder="Tell us about your travel plans, questions, or requirements..."
                  rows="5"
                  className="form-textarea"
                  disabled={isSubmitting}
                ></textarea>

                {errors.message && (
                  <span className="error-message">
                    {errors.message}
                  </span>
                )}

              </div>

            </div>


            {/* ================= SUBMIT ERROR ================= */}

            {errors.submit && (

              <div className="submit-error">

                <i className="fas fa-exclamation-circle"></i>

                <span>
                  {errors.submit}
                </span>

              </div>

            )}


            {/* ================= SUBMIT BUTTON ================= */}

            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >

              {isSubmitting ? (

                <>
                  <span className="spinner"></span>
                  Sending...
                </>

              ) : (

                <>
                  <span>Send Message</span>
                  <i className="fas fa-paper-plane"></i>
                </>

              )}

            </button>


            {/* ================= PRIVACY NOTE ================= */}

            <p className="form-note">

              <i className="fas fa-lock"></i>

              Your information is safe with us.
              We'll never share your details.

            </p>

          </form>

        )}

      </div>
    );
  }
}